import { useSelector } from 'react-redux';
import {
  getFirstAppliedFilter,
  supportedMetricsSelector,
  intervalSelector,
  realTimeModeOnTrendsSelector,
} from '@store/common/selectors';

function useQueryParams() {
  const interval = useSelector(intervalSelector);
  const { rule: filter, _rKey = 0 } = useSelector(getFirstAppliedFilter);
  const allowedMetrics: any = useSelector(supportedMetricsSelector);
  const realTimeOnTrends = useSelector(realTimeModeOnTrendsSelector);

  return {
    interval,
    filter,
    _rKey,
    allowedMetrics,
    liveMode: realTimeOnTrends,
  };
}

export default useQueryParams;
